<div class="ct-range-datepicker">
    <ul class="ct-hot-links-container">
        <li *ngFor="let period of datePeriodList" (click)="setPeriod(period)"><a>{{period.description}}</a></li>
    </ul>
    <div class="ct-datepicker-container">
        <ct-datepicker class="ct-datepicker" [required]="true"
                       [name]="'date'" ngModel
                       [firstDayOfWeek]="firstDayOfWeek"
                       [multiselect]="true"
                       [date]="selectedRange"
                       [displayDate]="displayDate"
                       (dateClicked)="dateOnClick($event)"></ct-datepicker>
    </div>
</div>
